/**
 * Format currency for compact display: $1.2M, $450K, $999
 * Uses M for millions, K for thousands; no suffix below 1K.
 */
export function formatCurrencyShort(value) {
  const num = Number(value) || 0;
  if (num >= 1_000_000) {
    const m = num / 1_000_000;
    return `$${m >= 10 ? m.toFixed(0) : m % 1 === 0 ? m.toFixed(0) : m.toFixed(1)}M`;
  }
  if (num >= 1_000) {
    const k = num / 1_000;
    return `$${k >= 10 ? k.toFixed(0) : k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)}K`;
  }
  return `$${num.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}
